import script from "./ClinicianTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClinicianTable.vue?vue&type=script&lang=ts&setup=true"

import "./ClinicianTable.vue?vue&type=style&index=0&id=7dc070da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc070da"]])

export default __exports__